import React from 'react'
import { IntlContext } from '../../utility/context/Internationalization'
import { IMAGE } from '../../configs/app-configs'
import classnames from 'classnames'
import { Link } from 'react-router-dom'

const LandingHeader = ({ isLanding2 }) => {
  return (
    <IntlContext.Consumer>
      {(context) => {
        return (
          <React.Fragment>
            <Link to='/'>
              <img
                src={isLanding2 ? IMAGE.LOGO : IMAGE.LOGO_WHITE}
                alt='logo'
              />
            </Link>
            <div className='languages d-flex align-items-center ' style={{paddingTop : '20px'}}>
              <div
                onClick={() => context.switchLanguage('vi')}
                className={classnames('mr-1 cursor-pointer font-weight-bold', {
                  'text-primary': context.state.locale === 'vi'
                })}
              >
                VIE
              </div>
              <div
                className='divider mr-1'
                style={{
                  height: '15px'
                }}
              ></div>
              <div
                onClick={() => context.switchLanguage('en')}
                className={classnames('mr-1 cursor-pointer font-weight-bold', {
                  'text-primary': context.state.locale === 'en'
                })}
              >
                ENG
              </div>
            </div>
          </React.Fragment>
        )
      }}
    </IntlContext.Consumer>
  )
}

export default LandingHeader
